import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import EventBgColorsData from "../../js/eventBgColorsData";
import localimgpath from "../../js/localimgpath";
import {
  Animatespin,
  SildeEventsCom,
  HeadingCom,
} from "../../components/index";
import Functions from "./index.function";

const Events = () => {
  const { formatEventDate, Events, isLoading, sliderSettings, handleEvents } =
    Functions();
    
  return (
    <div className="bg-primary">
      <div className="lg:px-5 xl:px-10 xs:px-3 xs:py-5 sm:px-6 sm:py-6 m-auto lg:pt-16">
        <HeadingCom title={"Events"} to={"/event"} />
      </div>
      <div className="lg:pt-14 xs:pt-5">
        {isLoading ? (
          <div className="w-full mx-auto">
            <Animatespin />
          </div>
        ) : (
          <div className="slider-container">
            <Slider {...sliderSettings}>
              {Events?.events?.map((value, index) => (
                <div 
                  key={index}
                  style={{ width: '360px' }} // Fixed width
                >
                  <div style={{ padding: '0 10px' }}> {/* 20px gap */}
                    <SildeEventsCom
                      isSlider={true} // Add this prop to disable internal width calculation
                      onClick={() => handleEvents(value?.id)}
                      eventthubmail={`${localimgpath?.eventsThumbnail}/${value?.hero_image}`}
                      eventsimgClassName={"h-[65%] object-cover"}
                      eventsTextClassName={"h-[35%]"}
                      maxWClassname={"w-full"}
                      textclassName={"lg:text-base"}
                      eventtheme={
                        EventBgColorsData[index % EventBgColorsData.length].eventtheme
                      }
                      eventTitle={value?.event_title}
                      evetDate={formatEventDate(value?.event_date)}
                      eventDis={value?.event_type}
                    />
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        )}
      </div>
    </div>
  );
};

export default Events;